import { useGraphQLClient } from 'providers';
import { useQueryClient } from '@tanstack/react-query';
import { SharedWith, useRemoveShare } from '../../graphql';
import useAccessToken from '../useAccessToken';

export const useRemoveShareMutation = (modelId?: string, modelType?: string) => {
  const { data: accessToken } = useAccessToken();

  const queryClient = useQueryClient();

  const { graphQLClient } = useGraphQLClient(accessToken);

  return useRemoveShare(graphQLClient, {
    onSuccess: (responseData, variables) => {
      if (modelId && modelType) {
        queryClient.setQueryData(
          ['sharedWithQuery', { model_id: modelId, model_type: modelType }],
          (oldData?: SharedWith) => ({
            ...oldData,
            sharedWith: oldData?.sharedWith?.filter((item) => item?.id !== variables.id),
          }),
        );
      }
    },
  });
};
